import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Pagination, Empty } from "antd";
import moment from "moment";

import {
  NewMembersAction,
  InterestAction,
  PhotoreqAction,
} from "../../store/actions";

import Spacer from "../../components/spacer/spacer";
import DashboardCard from "../../components/dashboardcard/dashboardcard";
import CardBottomButton from "../../components/dashboardcard/cardbottombutton";
import UnderHeaderMenu from "../../components/underheadermenu";
import DashboardMobileCard from "../../components/dashboardcard/dashboardmobilecard";
import Cardloader from "../../components/loader/cardloader";

import useScreenSize from "../../utils/usescreensize";

import images from "../../assets";

import "./styles.css";

const NewMembers = () => {
  const screenSize = useScreenSize();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();

  const defaultPage = parseInt(searchParams.get("page")) || 1;

  const { newMembers, isLoading, newMembersCount } = useSelector(
    (state) => state.newMembers
  );
  const { interestsAll } = useSelector((state) => state.interests);
  const { photoreqAll } = useSelector((state) => state.photoreq);

  const [pageNo, setPageNo] = useState(defaultPage);
  const [pageSize] = useState(8);

  useEffect(() => {
    const payload = {
      from: (pageNo - 1) * pageSize,
      size: pageSize,
    };
    dispatch(NewMembersAction.getNewMembers(payload));
  }, [pageNo]);

  useEffect(() => {
    setSearchParams({ page: pageNo.toString() });
  }, [pageNo]);

  useEffect(() => {
    const urlPage = parseInt(searchParams.get("page")) || 1;
    if (urlPage !== pageNo) {
      setPageNo(urlPage);
    }
  }, [searchParams]);

  const handlePageChange = (pageNumber) => {
    setPageNo(pageNumber);
  };

  const handleSendInterest = (id) => {
    const payload = { receiverId: id };
    dispatch(InterestAction.sendInterest(payload));
  };

  const handleSendPhotoReq = (id) => {
    const payload = { receiverId: id };
    dispatch(PhotoreqAction.sendPhotoreq(payload));
  };

  return (
    <div>
      {screenSize.width < 1023 && <UnderHeaderMenu />}
      <div className="recommended-container">
        <div className="header-container">
          <h1 className="section-heading">New Members</h1>
        </div>
        {isLoading ? (
          <Cardloader />
        ) : (
          <>
            {newMembers?.length > 0 ? (
              <>
                {screenSize.width > 768 ? (
                  <div className="recommended-matches-container">
                    {newMembers?.map((item, index) => {
                      const interestSent = interestsAll?.some(
                        (profile) => profile.receiverId === item?.username
                      );

                      const photoreqSent = photoreqAll?.some(
                        (profile) => profile.receiverId === item?.username
                      );
                      return (
                        <DashboardCard
                          item={item}
                          index={index}
                          key={index}
                          redirectedfrom="newMembers"
                        >
                          <div className="flex flex-col gap-3 w-full">
                            <div className="photoreq-card-text">
                              <p>Joined Date:</p>
                              <p>{moment(item?.createdAt).fromNow()}</p>
                            </div>
                            <div className="flex justify-between gap-3">
                              <CardBottomButton
                                icon={images.cardMessage}
                                onClick={() =>
                                  navigate(
                                    `/messages?username=${item?.username}&firstName=${item?.firstName}&lastName=${item?.lastName}&photo=${item?.profilePicture}`
                                  )
                                }
                                title="Send Message"
                              />
                              <CardBottomButton
                                icon={images.cardPhotoReq}
                                onClick={() =>
                                  handleSendPhotoReq(item?.username)
                                }
                                title="Send Photo Request"
                                disabled={photoreqSent}
                              />
                              <CardBottomButton
                                icon={images.cardmatch}
                                onClick={() =>
                                  handleSendInterest(item?.username)
                                }
                                title="Send Interest"
                                disabled={interestSent}
                              />
                            </div>
                          </div>
                        </DashboardCard>
                      );
                    })}
                  </div>
                ) : (
                  <>
                    {newMembers?.map((item, index) => (
                      <DashboardMobileCard
                        item={item}
                        index={index}
                        key={index}
                        showJoinedDate={true}
                      />
                    ))}
                  </>
                )}
                <Spacer height="36px" />
                <div className="flex justify-center items-center">
                  <Pagination
                    current={pageNo}
                    total={newMembersCount}
                    defaultPageSize={pageSize}
                    onChange={handlePageChange}
                    showSizeChanger={false}
                  />
                </div>
                <Spacer height="12px" />
              </>
            ) : (
              <Empty description={<p>No Results found</p>} />
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default NewMembers;
